const map = (state = [], action) => {

	switch (action.type) {

		case 'ADD_MARKERS': {

			const { type, markers } = action.options;

			return {
				...state,
				markers: {
					...state.markers,
					[type]: markers
				}
			};
		}

		case 'REMOVE_MARKERS': {

			const { type } = action.options;

			return {
				...state,
				markers: {
					...state.markers,
					[type]: []
				}
			};
		}
		case 'ADD_POLYLINES': {

			const { type, polylines } = action.options;

			return {
				...state,
				polylines: {
					...state.polylines,
					[type]: polylines
				}
			};
		}
		case 'REMOVE_POLYLINES': {

			const { type } = action.options;

			return {
				...state,
				polylines: {
					...state.polylines,
					[type]: []
				}
			};
		}

		case 'HIDE_POLYLINES': {

			const { polyLines } = action.options;

			return {
				...state,
				polylines: {
					// ...state.polylines,
					poly: polyLines
				}
			};
		}

		case 'ADD_POLYGONS': {

			const { type, polygons } = action.options;

			return {
				...state,
				polygons: {
					...state.polygons,
					[type]: polygons
				}
			};
		}

		case 'REMOVE_POLYGONS': {

			const { type } = action.options;

			return {
				...state,
				polygons: {
					...state.polygons,
					[type]: []
				}
			};
		}

		case 'ADD_OVERLAYS': {

			const { type, overlays } = action.options;

			return {
				...state,
				overlays: {
					...state.overlays,
					[type]: overlays
				}
			};
		}

		case 'REMOVE_OVERLAYS': {

			const { type } = action.options;

			return {
				...state,
				overlays: {
					...state.overlays,
					[type]: []
				}
			};
		}

		case 'SET_USER_LOCATION': {

			const { lat, lng } = action.options;

			return {
				...state,
				userLocation: {
					lat, lng
				}
			};
		}

		case 'SET_MANUAL_BOUNDS': {
			const { bounds } = action.options;

			return {
				...state,
				bounds
			};
		}

		case 'CLEAR_MAP': {

			const { type } = action.options;

			return {
				...state,
				markers: {
					...state.markers,
					[type]: []
				},
				polylines: {
					...state.polylines,
					[type]: []
				},
				polygons: {
					...state.polygons,
					[type]: []
				},
				overlays: {
					...state.overlays,
					[type]: []
				}
			};
		}

		case 'SET_IN_STREET_VIEW':
			return {
				...state,
				inStreetView: action.options.inStreetView
			};

		default:
			return state;
	}
}
export default map;



// WEBPACK FOOTER //
// ./src/reducers/map.js